import {
    Chart as ChartJS, CategoryScale, LinearScale, PointElement,
    LineElement, BarElement, Tooltip as ChartTooltip, Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Box, Card, CardContent, Grid, LinearProgress, Typography } from '@mui/material';

import { money } from '../../../helpers/admin/clients/clientHelper';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ChartTooltip, Legend);

const MetricCard = ({ label, value, helper }) => (
    <Grid item xs={12} sm={6} md={3}>
        <Card variant="outlined" sx={{ height: '100%' }}>
            <CardContent>
                <Typography variant="body2" color="text.secondary">{label}</Typography>
                <Typography variant="h5" sx={{ mt: 1, fontWeight: 700 }}>{value}</Typography>
                {helper && <Typography variant="caption" color="text.secondary">{helper}</Typography>}
            </CardContent>
        </Card>
    </Grid>
);

const CustomerOverview = ({ data, loading }) => {
    if (loading) return <LinearProgress />;
    if (!data) return <Typography color="text.secondary">No se pudo cargar el resumen.</Typography>;

    const trend = data.trend || [];
    const chartData = {
        labels: trend.map(item => item.period),
        datasets: [
            {
                label: 'Clientes nuevos', data: trend.map(item => item.new_customers),
                borderColor: '#04A6E1', backgroundColor: '#04A6E1', tension: 0.25
            },
            {
                label: 'Clientes recurrentes', data: trend.map(item => item.returning_customers),
                borderColor: '#358F69', backgroundColor: '#358F69', tension: 0.25
            }
        ]
    };

    return (
        <Box>
            <Grid container spacing={2}>
                <MetricCard label="Perfiles" value={data.total_customers || 0} helper="Incluye cuentas sin compra" />
                <MetricCard label="Compradores del periodo" value={data.buyers || 0} />
                <MetricCard label="Clientes nuevos" value={data.new_customers || 0} />
                <MetricCard label="Clientes recurrentes" value={data.returning_customers || 0} />
                <MetricCard label="Tasa de recompra" value={`${data.returning_rate || 0}%`} />
                <MetricCard label="Ventas aprobadas" value={money(data.approved_gross_sales)} helper="Incluye envío; no descuenta reembolsos" />
                <MetricCard label="Ticket promedio" value={money(data.average_order_value)} />
                <MetricCard
                    label="Intervalo de recompra"
                    value={data.average_repurchase_days === null ? '—' : `${data.average_repurchase_days} días`}
                />
            </Grid>
            <Card variant="outlined" sx={{ mt: 3 }}>
                <CardContent>
                    <Typography variant="h6" sx={{ mb: 2 }}>Nuevos y recurrentes</Typography>
                    {trend.length ? (
                        <Box sx={{ height: 340 }}>
                            <Line data={chartData} options={{
                                responsive: true, maintainAspectRatio: false,
                                scales: { y: { beginAtZero: true, ticks: { precision: 0 } } }
                            }} />
                        </Box>
                    ) : <Typography color="text.secondary">No hay compras en el periodo.</Typography>}
                </CardContent>
            </Card>
        </Box>
    );
};

export default CustomerOverview;
